import { z } from "zod";

export const UpdateOverheadCategorySchema = z.object({
  label: z.string().min(1, "Label is required").max(80, "Label cannot exceed 80 characters").trim(),
});

export const AddOverheadSubcategorySchema = z.object({
  name: z
    .string()
    .min(1, "Subcategory name is required")
    .max(80, "Name cannot exceed 80 characters")
    .trim(),
});

export const UpdateOverheadSubcategorySchema = z.object({
  name: z
    .string()
    .min(1, "Subcategory name is required")
    .max(80, "Name cannot exceed 80 characters")
    .trim(),
});

export type UpdateOverheadCategoryInput = z.infer<typeof UpdateOverheadCategorySchema>;
export type AddOverheadSubcategoryInput = z.infer<typeof AddOverheadSubcategorySchema>;
export type UpdateOverheadSubcategoryInput = z.infer<typeof UpdateOverheadSubcategorySchema>;
